import React, { Component } from 'react'
import '../styles/NavbarItem.css'

class NavbarItem extends Component {
  navbarItemStyle = () => {
    if (this.props.title.toLowerCase() === this.props.lang) {
      return "navbar-item-bold"
    } else {
      return ""
    }
  }
  render() {
    return(
      <div
        className={`${this.props.toggle ? 'navbar-item navbar-item--toggle' : 'navbar-item'} ${this.navbarItemStyle()}`}
        onMouseOver={this.props.openMenu}
        onMouseLeave={this.props.closeMenu}>
        {this.props.title}
        {this.props.children}
      </div>
    )
  }
}

export default NavbarItem




// WEBPACK FOOTER //
// ./src/components/NavbarItem.js